class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener(
      'keyup',
      evt => evt.code === 'Escape' && this.close(),
    );
    this.querySelectorAll('button[type="button"]').forEach(closeButton =>
      closeButton.addEventListener('click', this.close.bind(this)),
    );
  }

  open() {
    const noti = this.querySelector('.cart-notification-wrapper');
    noti.classList.add('show');

    document.body.addEventListener('click', this.onBodyClick);

    this.querySelector('.continue').onclick = this.onBodyClick;
  }

  close() {
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach(section => {
      console.log({ section, parsedState });
      switch (section.id) {
        case 'cart-icon-bubble':
          const bubble = document.getElementById(section.id);
          const bubbleCount = document.querySelector('.cart-count-bubble');

          if (bubbleCount) {
            bubbleCount.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.id],
              '.cart-count-bubble',
            );
          } else {
            bubble.innerHTML += this.getSectionOuterHTML(
              parsedState.sections[section.id],
              '.cart-count-bubble',
            );
          }
          bubble.classList.add('show');
          break;
        case 'cart-notification-product':
          const notification = document.getElementById(section.id);

          notification.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.id],
            section.selector,
          );
          break;
      }
    });

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
  getSectionOuterHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).outerHTML;
  }

  handleBodyClick(evt) {
    const noti = this.querySelector('.cart-notification-wrapper');
    noti.classList.remove('show');
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
